import React from 'react';
import PropTypes from 'prop-types';

import {Formik} from 'formik';

import FormComponent from './FormComponent';

import {DisplayFormikState} from 'components/DisplayFormikState';

import ValidationSchema from './ValidationSchema';

const ConfirmForm = ({ record, handleSubmit }) => {
    const onSubmit = (values) => {
        return handleSubmit(values);
    };

    const renderForm = (props) => {
        return (
            <React.Fragment>
                <FormComponent {...props} />
                {false && <DisplayFormikState {...props} />}
            </React.Fragment>
        );
    };

    let initialValues = {
        otc: '',
        new_password: '',
        confirm_password: '',
    };

    if (record) {
        initialValues = record;
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ValidationSchema}
            onSubmit={onSubmit}
        >
            {renderForm}
        </Formik>
    );
};

ConfirmForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func,
};

export default ConfirmForm;
